import { render } from "./FooterBottom.vue?vue&type=template&id=45feba7c&scoped=true"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"

import "./FooterBottom.vue?vue&type=style&index=0&id=45feba7c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\feegor\\PycharmProjects\\menlor\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45feba7c"]])

export default __exports__